import { CLEAR_SITE_DATA } from '../application';
import { RECEIVED_TYPES } from './actions';

const initialState = {
  types: [],
};

export function reducer(state = structuredClone(initialState), action) {
  switch (action.type) {
    case RECEIVED_TYPES: {
      return { ...state, types: action.types };
    }
    case CLEAR_SITE_DATA: {
      return structuredClone(initialState);
    }
    default: {
      return state;
    }
  }
}
